const endpoint = "https://api.satyampropertyconsultancy.com";

export default endpoint;